<template>
  <vue-modal classes="vue-modal-container"
             height="auto"
             name="log-in-modal"
             width="300px">
    <div class="header">
      <h3>{{ trans.header }}</h3>
      <button class="close-modal"
              @click="$modal.hide('log-in-modal')">
        <i class="close icon"/>
      </button>
    </div>
    <div class="content">
      <div class="ui form">
        <div class="field">
          <label>{{ trans.emailLabel }}
            <input v-model="loginEmail"
                   :placeholder="trans.emailPlaceholder"
                   type="email"
                   @keyup.enter="logMeIn">
          </label>
        </div>
        <div class="field">
          <label>{{ trans.pwdLabel }}
            <input v-model="loginPwd"
                   type="password"
                   @keyup.enter="logMeIn">
          </label>
        </div>
        <div class="row collapse">
          <div class="small-12 columns">
            <span class="forgottenPasswordBtn"
                  @click="forgottenPasswordRequest">{{ trans.forgottenPwdBtnText }}</span>
          </div>
          <div class="small-12 medium-12 columns sign-in-btn-container">
            <button class="ui primary button"
                    @click="logMeIn">{{ trans.loginBtnText }}
            </button>
          </div>
          <!--
          <div class="small-6 medium-6 columns">
            <button class="ui facebook button"
                    @click="facebookClick">
              <i class="facebook icon"></i>
              Facebook
            </button>
          </div>
          <div class="small-6 medium-6 columns">
            <button class="ui google plus button"
                    @click="googleClick">
              <i class="google plus icon"></i>
              Google
            </button>
          </div>
          -->
        </div>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import notify from '@/notify'
import config from '@/config'
import {mapState} from 'vuex'

export default {
  props: ['isLoggedIn'],
  data () {
    return {
      loginEmail: '',
      loginPwd: '',
      googleLoginUrl: config.GOOGLE_LOGIN_URL,
      facebookLoginUrl: config.FACEBOOK_LOGIN_URL,
    }
  },
  methods: {
    logMeIn () {
      this.$emit('login', { email: this.loginEmail, pwd: this.loginPwd })
    },
    forgottenPasswordRequest () {
      if (this.loginEmail) {
        this.$emit('forgotten-password-request', { email: this.loginEmail })
      } else {
        notify.warning('Adja meg az email címet az új jelszó kéréséhez')
      }
    },
    facebookClick () {
      location.href = this.facebookLoginUrl
    },
    googleClick () {
      location.href = this.googleLoginUrl
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.loginModal,
    }),
  },
  mounted: function () {
    /*
    this.$nextTick(function () {
      // induláskor megnyitja a bejelentkezést
      if (!this.isLoggedIn) {
        // eslint-disable-next-line
        this.$modal.show('log-in-modal')
      }
    })
    */
  },
}
</script>


<style scoped>
.button {
  width: 100%;
}

.sign-in-btn-container {
  margin-bottom: 0.5rem;
}

.forgottenPasswordBtn {
  font-size: 80%;
  font-weight: 700;
  color: rgba(0, 0, 0, .87);
  text-transform: none;
  cursor: pointer;
}
</style>
